'use client'

import { INode } from '@/api/nodes/mutations/directory/create-directory-mutation'
import { useDirectoryContext } from '@/features/drive/entities/directory/directory-context'
import { useCallback, useState } from 'react'

export const useDirectoryNavigationManger = () => {
    const { setSlugs, slugs } = useDirectoryContext()

    const [previewFile, rawSetPreviewFile] = useState<INode | null>(null)

    const setPreviewFile = useCallback((nextNode: INode | null) => {
        if (!nextNode || nextNode.type !== 'FILE') {
            rawSetPreviewFile(null)
            return
        }

        rawSetPreviewFile(nextNode)
    }, [])

    const goToNode = useCallback(
        (node: INode) => {
            if (!node?.slug) return

            switch (node.type) {
                case 'DIRECTORY':
                    setSlugs([...slugs, node.slug])

                case 'FILE':
                    rawSetPreviewFile(node)
                    break
            }
        },
        [slugs, setSlugs]
    )

    const closePreviewFile = useCallback(() => {
        rawSetPreviewFile(null)
    }, [])

    return {
        // TODO: @aron currently two ways to access the preview file, through the context and through this hook. We should reduce it to one interface to interact with the preview file.
        previewFile,
        closePreviewFile,
        goToNode,
        openPreviewFile: setPreviewFile,
    }
}
